(() => {
  const iconUrl = document.currentScript?.dataset.spendSaveIconUrl;
  const safeLink = value => typeof value === 'string' && /^(?:\/(?!\/)|https:\/\/[a-z\d.-]+(?::\d+)?(?:[/?#]|$))[^\s\\<>"']*$/i.test(value);
  window.EdenmereSpendSaveTheme = {iconUrl};
  let lastWording = null;
  function refresh() {
    document.querySelectorAll('[data-ess-component="rail"][data-ess-width]').forEach(mount => {
      const tiers = mount.querySelector('.ess[data-ess-surface="cart"] .ess__tiers');
      if (!tiers) return;
      const width = Number(mount.dataset.essWidth);
      tiers.style.setProperty('--ess-basket-rail-fraction', String(width >= 10 && width <= 100 ? width / 100 : 1));
      tiers.style.setProperty('--ess-basket-rail-intervals', String(tiers.children.length - 1));
    });
    // Presentation only: the provider continues reading exact native titles.
    document.querySelectorAll('[data-spend-save-discount-title]').forEach(node => {
      node.textContent = node.textContent.replace(/^(Spend & Save|Edenmere Club) (\d+(?:\.\d+)?)% #S\d+[PM](?:-\d+)?$/, '$1 $2%');
    });
    const config = window.EdenmereSpendSave?.getPublishedConfig?.();
    if (config != null) lastWording = config.schemaVersion === 2 ? config.wording || {} : null;
    const wording = lastWording || {};
    const value = wording.placements?.cart?.cartHeadingUrl ?? wording.cartHeadingUrl;
    const destination = safeLink(value) ? value : '';
    const selectedImage = wording.eligibilityImage;
    const imageSizes = {small: 16, medium: 24, large: 32};
    const useSelectedImage = selectedImage && /^https:\/\/cdn\.shopify\.com\/[^\s<>"']+$/.test(selectedImage.url) && Object.hasOwn(imageSizes, selectedImage.size);
    const headingIconUrl = useSelectedImage ? selectedImage.url : iconUrl;
    const iconWidth = useSelectedImage ? imageSizes[selectedImage.size] : 36;
    const iconHeight = useSelectedImage ? iconWidth : 24;
    document.querySelectorAll('.ess[data-ess-surface="cart"] .ess__title').forEach(heading => {
      if (!headingIconUrl || !heading.textContent.trim()) return;
      const currentIcon = heading.querySelector('[data-ess-heading-icon]');
      if (heading.dataset.essHeadingDestination === destination && currentIcon?.getAttribute('src') === headingIconUrl && currentIcon.getAttribute('width') === String(iconWidth) && currentIcon.getAttribute('height') === String(iconHeight)) return;
      const text = heading.textContent;
      const icon = document.createElement('img');
      icon.src = headingIconUrl;
      icon.alt = '';
      icon.width = iconWidth;
      icon.height = iconHeight;
      icon.className = 'spend-save-icon';
      icon.dataset.essHeadingIcon = '';
      if (useSelectedImage) {
        icon.style.width = `${iconWidth}px`;
        icon.style.height = `${iconHeight}px`;
        icon.style.objectFit = 'contain';
      }
      let content = document.createTextNode(text);
      if (destination) {
        content = document.createElement('a');
        content.href = destination;
        content.target = '_blank';
        content.rel = 'noopener noreferrer';
        content.dataset.essHeadingLink = '';
        content.textContent = text;
      }
      heading.replaceChildren(icon, content);
      heading.dataset.essHeadingDestination = destination;
    });
  }
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; refresh(); });
  };
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) schedule();
  }).observe(document.documentElement, {childList: true, subtree: true});
  for (const event of ['DOMContentLoaded', 'shopify:section:load', 'edenmere:spend-save:state-change', 'edenmere:spend-save:modules-ready']) document.addEventListener(event, schedule);
  refresh();
})();
